import styled from 'styled-components';

export const Input = styled.input`
    border : 0;
    padding : 10px;
    box-sizing : border-box;
    border-radius : 10px;
    margin-top : 10px;
    outline : none;

`;

export const TitleInput = styled.input`
    outline : none;
    border : 1px solid #d3d3d3;
    padding : 10px;
    margin: 10px 0;


`;

export const CategoryInput = styled.input`
    outline : none;
    border : 0;
    width : 120px;

`;


